module.exports = __webpack_public_path__ + "2903775100d4c1679a849bdce4a3f800.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-10.png
// module id = 2655
// module chunks = 0